






















































import { computed, defineComponent, Ref, ref } from '@vue/composition-api';
import { TranslateResult }                     from 'vue-i18n';
import { useGlobals }                          from '@/hooks/use-globals';
import useGlobalTranslations                   from '@/hooks/use-global-translations';
import { DrawerAttributes, DrawerPanelProps }  from '@/components/drawer/drawer.types';
import { Computed }                            from '@/types';
import cDrawerPanel                            from '@/components/drawer/drawer-panel/drawer-panel.component.vue';
import cForm                                   from '@/components/form/form/form.component.vue';
import cFormItem                               from '@/components/form/form-item/form-item.component.vue';
import cInput                                  from '@/components/form/input/input.component.vue';
import cIconTrashCan                           from '@/components/icons/icon-trash-can.component.vue';
import cColorPicker                            from '@/components/color-picker/color-picker.component.vue';
import { changeColorInHex, colorParser }       from '@/styles/variables.helpers';
import { SeasonFields }                        from '@/views/seasons/seasons.types';

export default defineComponent({
  name: 'cAddSeason',
  components: {
    cDrawerPanel,
    cForm,
    cFormItem,
    cInput,
    cIconTrashCan,
    cColorPicker,
  },
  setup(props, context) {
    const { store, i18n } = useGlobals();
    const model: Computed<SeasonFields> = computed(() => store.state.views.vSeasons.modal.form.originalFields);
    const editMode: Computed<boolean> = computed(() => store.state.views.vSeasons.modal.mode === 'EDIT');
    const buttonSave: TranslateResult = useGlobalTranslations('buttons.save');
    const lastSelectedColorIdx: Ref<number> = ref(0);
    const seasonPanel: Ref<HTMLElement | null> = ref(null);

    const panelAttrs: Computed<DrawerAttributes> = computed(() => ({
      visible: store.state.views.vSeasons.modal.open,
      size: '45rem',
      title: `${i18n.t(`vSeasons.sidePanel.${editMode.value ? 'editSeason' : 'newSeason'}`)}`,
    }));

    const drawerPanelProps: Computed<DrawerPanelProps> = computed(() => ({
      button: buttonSave as string,
      isLoading: false,
      panelAttrs: panelAttrs.value,
    }));

    const predefine: Computed<string[]> = computed(() => [
      '#00D2FF',
      '#F20058',
      '#FA957F',
      '#FFDE1A',
      '#FF83C8',
      '#2C3137' ]);

    const showColorPicker = (color: string, index: number): void => {
      const colorPicker: HTMLElement | null = document.querySelector<HTMLElement>('.el-color-picker__trigger');
      lastSelectedColorIdx.value = index;

      if (colorPicker) {
        colorPicker.dispatchEvent(new Event('click'));
      }

      store.commit('views/vSeasons/updateForm', { color });
    };

    const setColor = (color: string): void => {
      store.commit('views/vSeasons/updateForm', { color: colorParser(color.substring(5, color.length - 1)) });

      if (seasonPanel.value) {
        seasonPanel.value.style.setProperty('--selected-color', changeColorInHex(model.value.color, 30, false));
      }
    };

    const save = (): void => {
      const mutationName = editMode.value ? 'views/vSeasons/editSeason' : 'views/vSeasons/addSeason';
      store.commit(mutationName, model.value);
      context.emit('onDrawerClose');
    };

    const removeSeason = (): void => {
      store.commit('views/vSeasons/removeSeason', model.value.code);
      context.emit('onDrawerClose');
    };

    return {
      i18n,
      drawerPanelProps,
      panelAttrs,
      model,
      predefine,
      lastSelectedColorIdx,
      seasonPanel,
      showColorPicker,
      setColor,
      save,
      removeSeason,
    };
  },
});
